import {
  ImgHTMLAttributes,
  PropsWithChildren,
  SyntheticEvent,
  useCallback,
  useState
} from 'react';

import './style.scss';

export interface Props extends ImgHTMLAttributes<HTMLImageElement> {
  src: string;
}

// image element with on loaded animation
export default function Img({
  src,
  className = '',
  onLoad,
  ...rest
}: PropsWithChildren<Props>) {
  const [isLoaded, setIsLoaded] = useState(false);

  const onLoadMethod = useCallback(
    (e: SyntheticEvent<HTMLImageElement>) => {
      if (onLoad) onLoad(e);

      setIsLoaded(true);
    },
    [onLoad]
  );

  return (
    <>
      {!isLoaded && <span className={`img placeholder ${className}`} />}
      <img
        {...rest}
        className={['img', isLoaded && 'visible', className]
          .filter(Boolean)
          .join(' ')}
        src={src}
        onLoad={onLoadMethod}
      />
    </>
  );
}
